import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  useMediaQuery,
  Box,
  Avatar,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import logoMan from "../../../assets/images/logoman.png";
import WorkIcon from "@mui/icons-material/Work";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import StarIcon from "@mui/icons-material/Star";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DescriptionIcon from "@mui/icons-material/Description";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleIcon from "@mui/icons-material/People";
import Accountmenu from "../../menu/Accountmenu";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { useIds } from "../../../hook/AdminContext";
import { s3baseUri } from "../../../config/config";
import { show_proper_words, sourceAccessMap } from "../../../utils/Constant";
import { ExpandMore, ExpandLess, ArrowBack } from "@mui/icons-material";
import { Icon } from "@iconify/react/dist/iconify.js";
import PostJoboUTSIDE from "../../../pages/post/PostJobOutSide";
import { get_outside_jobs_api } from "../../../DAL/partner/partners";
import { enqueueSnackbar } from "notistack";

const Sidebar = ({ currentSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerHeight, setDrawerHeight] = useState(900);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sourceId, setsourceId] = useState(null);
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [partnersObj, setPartnersObj] = useState({});
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const [loading, setLoading] = useState(false);

  const load_more_path = "api/jobs/list?page=0&limit=50";

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const { ids, userInfo, sourceSectionIds, setSourceSectionIds, findId } =
    useIds();
  const { pathname } = location;
  const firstSegment = location.pathname.split("/")[1];

  const handleNavigate = () => {
    navigate("/favourite-jobs");
  };

  const openAccount = Boolean(anchorEl);

  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.screen.width; // resolution
      const zoom = window.devicePixelRatio || 1;

      const baseHeight = 600;
      const maxExtra = 300;

      const resolutionFactor = (1920 - screenWidth) / 1920; // e.g. 1366 → 0.28
      const zoomFactor = (zoom - 1) * 200;

      let totalHeight = baseHeight + resolutionFactor * maxExtra + zoomFactor;
      totalHeight = Math.min(totalHeight, 900); // optional max cap

      setDrawerHeight(totalHeight);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [drawerHeight]);
  const handleSummarizeClick = () => {
    if (userInfo?.type === 2) {
      const accessibleSource = sourceAccessMap.find(({ title }) =>
        userInfo?.source?.some((source) => source.title === title)
      );
      navigate(accessibleSource?.path || "/home");
    }
  };
  const handleOpen = () => {
    setOpen(true);
    setEditMode(false);
  };
  const handleCloseJobPanel = () => {
    setOpen(false);
  };

  const fetchCategories = async (path, search, loading, id) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    if (firstSegment === "home") {
      id = "";
    } else {
      id = localStorage.getItem("source_id") || findId;
    }

    const response = await get_outside_jobs_api(id, search, path);

    for (let i = 0; i < response.jobs?.length; i++) {
      for (let j = 0; j < response.jobs[i].job_applicants.length; j++) {
        if (
          userInfo?.user_id?._id === response.jobs[i]?.job_applicants[j]?.userId
        ) {
          response.jobs[i].created_by_me = true;
        }
      }
    }

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);

      if (loading) {
        let new_array = categories.concat(response.jobs);
        setCategories(new_array);
        setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.jobs);
        setPageNumber(1);
      }

      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const handleNewSideBar = (item) => {
    let SideData = userInfo?.feature;
    if (userInfo?.type === 1) {
      const desiredOrder = [
        "68242ab625684254f8c1be40", // Leaders In The Industry
        "68242a7825684254f8c1be3e", // Interview
        "68242acb25684254f8c1be42", // HR
        "68242ae625684254f8c1be44", // Training Source
        "68242b7c25684254f8c1be4c", // Clients
        "68242b4e25684254f8c1be48", // Agency Partners
        "68242b6825684254f8c1be4a", // Industry Partners
        "68242be925684254f8c1be54", // Industry Suppliers
        "68242b3725684254f8c1be46", // Mindset Source
        "68242b9a25684254f8c1be4e", // Job Description
        "68242bcb25684254f8c1be52", // Temping
        "68242bb225684254f8c1be50", // Live Job Feed
      ];

      const sortedItems = [...item].sort((a, b) => {
        return desiredOrder.indexOf(a._id) - desiredOrder.indexOf(b._id);
      });

      const matchedItems = sortedItems
        .filter((section) =>
          SideData.some(
            (feature) => String(feature?.feature_id) === String(section._id)
          )
        )
        .map((section) => ({
          text: section.title,
          path: `/${firstSegment}${section.path}`,
          icon: s3baseUri + section.icon_image,
          _id: section._id,
        }));

      return [
        {
          text: ` ${show_proper_words(firstSegment)} Home`,
          path: `${firstSegment}`,
          icon: <HomeOutlinedIcon />,
          _id: ids[0]?._id || "", // Use first id if available
        },
        ...matchedItems,
      ];
    }

    return [
      {
        // text: `Home  ${show_proper_words(firstSegment)} `,
        text: ` ${show_proper_words(firstSegment)} Home`,
        path: `${firstSegment}`,
        icon: <HomeOutlinedIcon />,
        _id: ids[0]?._id || "", // Use first id if available
      },
      {
        text: "Leaders In The Industry",
        path: `/${firstSegment}/leader-in-the-industry`,
        icon: <StarIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Interview",
        path: `/${firstSegment}/interview`,
        icon: <RecordVoiceOverIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "HR",
        path: `/${firstSegment}/hr`,
        icon: <BusinessCenterIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Training Source",
        path: `/${firstSegment}/training-source`,
        icon: <ModelTrainingIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Clients",
        path: `/${firstSegment}/clients`,
        icon: <PeopleIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Agency Partners",
        path: `/${firstSegment}/partners`,
        icon: <PeopleIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Industry Partners",
        path: `/${firstSegment}/industry-partners`,
        icon: <PeopleIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Industry Suppliers",
        path: `/${firstSegment}/suppliers`,
        icon: <PeopleIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Mindset Source",
        path: `/${firstSegment}/mindset-source`,
        icon: <PsychologyAltIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Job Description",
        path: `/${firstSegment}/job-description`,
        icon: <DescriptionIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Temping",
        path: `/${firstSegment}/temping`,
        icon: <WorkIcon />,
        _id: localStorage.getItem("source_id"),
      },
      {
        text: "Live Job Feed",
        path: `/${firstSegment}/live-job-feed`,
        icon: <RssFeedIcon />,
        _id: localStorage.getItem("source_id"),
      },
    ];
  };

  const sidebarData = (items) => {
    const homeItem = {
      text: "Home",
      icon: <HomeOutlinedIcon />,
      path: "/home",
      _id: items[0]?._id || "",
    };

    const SideData = userInfo?.source;

    let dynamicItems = [];

    if (SideData?.length > 0) {
      dynamicItems = items
        .filter((item) =>
          SideData.some(
            (source) => String(source?.source_id) === String(item._id)
          )
        )
        .map((item) => ({
          text: item.title,
          path: item.path,
          icon: s3baseUri + item.icon_image,
          _id: item._id,
        }));
    } else if (userInfo?.type === 1) {
      dynamicItems = items.map((item) => ({
        text: item.title,
        path: item.path,
        icon: s3baseUri + item.icon_image,
        _id: item._id,
      }));
    }

    return [homeItem, ...dynamicItems];
  };

  let sideBar =
    currentSidebar === "main"
      ? sidebarData(ids)
      : handleNewSideBar(sourceSectionIds);

  const smartBack = () => {
    navigate(-1);
  };

  const showBackButton = pathname !== "/dashboard" && pathname !== "/home";
  const iconColor = "#000080";

  const sidebarContent = (
    <List
      sx={{
        p: 2,
        // marginBottom: "80px !important",
        minHeight: "95vh",
      }}
    >
      {sideBar.map((item, index) => {
        const isHome = item.text.endsWith("Home");
        const isActive =
          (isHome && `/${firstSegment}` === location.pathname) ||
          location.pathname === item.path ||
          (location.pathname.startsWith(`${item.path}/`) &&
            item.path.split("/").length > 2);

        return (
          <ListItem
            key={index}
            button
            component={Link}
            to={item.path}
            onClick={() => {
              navigate(item.path);
              if (item._id && currentSidebar === "main") {
                localStorage.setItem("source_id", item._id);
              }
            }}
            sx={{
              bgcolor: isActive ? "#000080" : "#fff",
              color: isActive ? "#fff" : "#000",
              borderRadius: 1,
              mb: 1,
              boxShadow: isActive
                ? "0px 3px 6px rgba(0, 0, 0, 0.2)"
                : "0px 2px 2px rgba(0, 0, 0, 0.11)",
              padding: "5px",
              "&:hover": {
                bgcolor: "#000080",
                color: "#fff",
                cursor: "pointer",
                "& .MuiListItemIcon-root": {
                  color: "#fff",
                },
              },
            }}
          >
            <ListItemIcon
              sx={{
                color: isActive ? "#fff" : "#DAA520",
                "&:hover": {
                  color: "#DAA520",
                },
              }}
            >
              {typeof item.icon === "string" ? (
                <img
                  src={item.icon}
                  style={{
                    width: 24,
                    height: 24,
                    filter: isActive ? "brightness(0) invert(1)" : "none",
                  }}
                />
              ) : (
                item.icon
              )}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        );
      })}
    </List>
  );

  return (
    <>
      <PostJoboUTSIDE
        refreshlist={fetchCategories}
        loadMorePath={load_more_path}
        searchTerm={searchTerm}
        loadingstate={loading}
        id={findId || localStorage.getItem("source_id")}
        open={open}
        handleClose={handleCloseJobPanel}
        editMode={editMode}
        jobData={selectedJob}
        sourceId={sourceId}
      />
      {isSmallScreen && (
        <AppBar position="fixed" sx={{ bgcolor: "#fff", zIndex: 1200 }}>
          <Toolbar
            sx={{
              minHeight: "61px !important",
              display: "flex",
              justifyContent: "space-between",
              overflow: "hidden",
              px: 1,
              gap: 1,
            }}
          >
            {/* Left Section - Menu and Back Button */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: 0,
              }}
            >
              {showBackButton && (
                <Tooltip title="Go Back">
                  <IconButton
                    onClick={smartBack}
                    size="small"
                    sx={{
                      color: iconColor,
                      animation: "bounceLeftRight 1s infinite",
                      "&:hover": { animation: "none" },
                      p: 0.5,
                    }}
                  >
                    <ArrowBack fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              <IconButton
                edge="start"
                color="inherit"
                onClick={() => setDrawerOpen(true)}
                sx={{ color: "#000080", p: 0.5 }}
                size="small"
              >
                <MenuIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Center Title */}
            <Typography
              variant="subtitle1"
              sx={{
                flexGrow: 1,
                color: "#000080",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                px: 0.5,
                fontSize: "1rem",
                fontWeight: 600,
                display: currentSidebar === "main" ? "block" : "none",
                maxWidth: "calc(100vw - 180px)",
              }}
            >
              Sources
            </Typography>

            {/* Right Section - Icons and Avatar */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: { xs: 0.5, sm: 1 },
                minWidth: 0,
              }}
            >
              {/* Favorite/Job Posting Icons */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  "& .MuiTypography-body2": {
                    display: { xs: "none", sm: "block" },
                  },
                }}
              >
                {Array.isArray(userInfo?.source) &&
                  userInfo.type === 1 &&
                  userInfo.source.length > 0 && (
                    <Tooltip title="View Favorite Jobs">
                      <IconButton
                        onClick={handleNavigate}
                        size="small"
                        sx={{ p: 0.5, color: "#000080" }}
                      >
                        <BookmarkIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}

                {userInfo?.type === 2 && (
                  <>
                    <Tooltip title="Post Job">
                      <IconButton
                        size="small"
                        sx={{ p: 0.1, color: "#000080" }}
                        onClick={handleOpen}
                      >
                        <Icon icon="ic:round-post-add" width={22} height={22} />
                      </IconButton>
                    </Tooltip>

                    {/* Vertical separator line */}
                    <Box
                      sx={{
                        height: "20px",
                        width: "1px",
                        backgroundColor: "rgba(0, 0, 0, 0.12)",
                        mx: 0.1,
                        my: "auto",
                      }}
                    />

                    <Tooltip title="My Job Posts">
                      <IconButton
                        size="small"
                        sx={{ p: 0.5, color: "#000080" }}
                        onClick={handleSummarizeClick}
                      >
                        <Icon
                          icon="streamline-flex:search-category-remix"
                          width={16}
                          height={16}
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </Box>

              {/* Avatar with Dropdown */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  ml: 0.5,
                }}
                onClick={(event) => setAnchorEl(event.currentTarget)}
              >
                <Box sx={{ position: "relative" }}>
                  <Avatar
                    src={s3baseUri + userInfo?.profile_image}
                    sx={{
                      width: 32,
                      height: 32,
                      border: "none",
                    }}
                  />
                  {openAccount ? (
                    <ExpandLess
                      sx={{
                        position: "absolute",
                        bottom: -4,
                        right: -4,
                        fontSize: "14px",
                        backgroundColor: "white",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <ExpandMore
                      sx={{
                        position: "absolute",
                        bottom: -4,
                        right: -4,
                        fontSize: "14px",
                        backgroundColor: "white",
                        borderRadius: "50%",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Box>

            <Accountmenu
              anchorEl={anchorEl}
              open={openAccount}
              handleClose={handleClose}
            />
          </Toolbar>
        </AppBar>
      )}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        variant={isSmallScreen ? "temporary" : "permanent"}
        sx={{
          zIndex: 1300,
          "& .MuiDrawer-paper": {
            width: isSmallScreen ? 240 : 259,
            mt: isSmallScreen ? 0 : 8,
            height: "100%",
            transition: "all 0.3s ease",
            position: isSmallScreen ? "fiexed" : "inherit",
          },
        }}
      >
        {!isSmallScreen && (
          <div style={{ marginLeft: "24px" }} className="mt-1 mb-0">
            {" "}
            <h4
              style={{
                fontSize: "17px",
                fontWeight: "bold",
                marginBottom: "0px",
                marginTop: "13px",
              }}
            >
              {currentSidebar === "main" ? "Sources" : ""}
            </h4>
          </div>
        )}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            px: 0,
          }}
          onClick={() => {
            if (isSmallScreen) setDrawerOpen(false);
          }}
        >
          {sidebarContent}
        </Box>
      </Drawer>
    </>
  );
};

export default Sidebar;
